import {Link} from "react-router-dom";

export const Home = () => {
    return <div>
            HOME
    </div>;
}